import { render, staticRenderFns } from "./TeamProfile.vue?vue&type=template&id=3c60b278&scoped=true&"
import script from "./TeamProfile.vue?vue&type=script&lang=js&"
export * from "./TeamProfile.vue?vue&type=script&lang=js&"
import style0 from "./TeamProfile.vue?vue&type=style&index=0&id=3c60b278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c60b278",
  null
  
)

export default component.exports